import React from "react";
import styled from "styled-components";
import Button from "../cta/Button";

interface ExportModalProps {
  onClose: () => void;
  onExportAll: () => void;
  onExportSelection: () => void;
  isLoadingAll?: boolean;
  isLoadingSelection?: boolean;
  selectedCount?: number;
}

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1500;
`;

const ModalContent = styled.div`
  display: flex;
  width: 400px;
  padding: 40px;
  flex-direction: column;
  align-items: flex-start;
  gap: 24px;
  border-radius: 18px;
  background: #232129;
  position: relative;
`;

const Title = styled.h2`
  color: var(--White_high, rgba(255, 255, 255, 0.9));
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Sharp Sans";
  font-size: 24px;
  font-style: normal;
  font-weight: 700;
  line-height: normal;
  margin: 0;
`;

const Description = styled.p`
  color: #fff;
  font-feature-settings: "liga" off, "clig" off;
  font-family: "Sharp Sans";
  font-size: 14px;
  font-style: normal;
  font-weight: 500;
  line-height: normal;
  margin: 0;
`;

const ButtonContainer = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;
  flex-direction: column;
`;

const CloseButton = styled.button`
  position: absolute;
  top: 20px;
  right: 20px;
  background: none;
  border: none;
  font-size: 24px;
  color: white;
  cursor: pointer;
  padding: 5px 10px;
`;

const ExportModal: React.FC<ExportModalProps> = ({
  onClose,
  onExportAll,
  onExportSelection,
  isLoadingAll = false,
  isLoadingSelection = false,
  selectedCount = 0,
}) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <CloseButton onClick={onClose}>&times;</CloseButton>
        <Title>Exporter</Title>
        <Description>Que voulez-vous exporter ?</Description>
        <ButtonContainer>
          <Button
            typeButton="primary"
            onClick={onExportAll}
            isLoading={isLoadingAll}
            stretch
          >
            Tout
          </Button>
          <Button
            typeButton="secondary"
            onClick={onExportSelection}
            isLoading={isLoadingSelection}
            stretch
            disabled={selectedCount === 0}
          >
            La sélection ({selectedCount})
          </Button>
        </ButtonContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default ExportModal;
